import { inject } from '@angular/core';
import {
  checkbox,
  fieldGroup,
  FormFieldsCustomizer,
  input,
  insertFieldAfter,
  insertFieldBefore,
  number,
  selectLazy,
} from '@kinet-open-network/client/core/forms/ui';
import { CustomerDetailComponent } from '@kinet-open-network/client/customers/feature/detail';
import {
  PaymentType,
  PaymentTypesService,
} from '@kinet-open-network/client/payment-types/data-access';

export const customerFieldsCustomizer: FormFieldsCustomizer<
  CustomerDetailComponent
> = (fields) => {
  const paymentTypesService = inject(PaymentTypesService);

  const paymentTypeFieldBuilder = selectLazy<PaymentType>(
    'paymentType',
    'Typ platby',
    'name',
    'id',
  )
    .query(paymentTypesService)
    .props({ showClear: true });
  insertFieldBefore(fields, 'sipoNumber', paymentTypeFieldBuilder);

  insertFieldAfter(
    fields,
    'companyCustomer',
    checkbox('isSupplier', 'Dodávateľ')
      .className('col-start-1')
      .defaultValue(false),
  );

  insertFieldAfter(
    fields,
    'isSupplier',
    checkbox('isFillingPlant', 'Plniareň').defaultValue(false),
  );

  fields.push(
    fieldGroup()
      .fieldGroupClassName(
        'grid grid-cols-[repeat(auto-fit,minmax(210px,1fr))] gap-x-4 items-start',
      )
      .fieldGroup([
        input('deliveryFeeSku', 'Poplatok za doručenie (SKU)'),
        number('dueDays', 'Splatnosť (počet dní)').int(),
      ])
      .build(),
  );
  return fields;
};
